module.exports = __webpack_public_path__ + "c2f8f7e9724a1caef05857ad2f828c94.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg25.jpeg
// module id = 34
// module chunks = 0